<template>
  <div>
    <v-text-field
      v-model="input.title"
      label="Title"
      v-on:keydown="searchTimer"
      hide-details="true"
      @keyup.enter="search"
    ></v-text-field>
    <v-list v-if="results.length > 0" id="queryResult">
      <template v-for="item in results">
        <v-list-item class="pt-1 pb-1" :key="item.id" v-on:click="selectWork(item)">
          <div class="d-flex justify-start">
            <v-img :src="item.posterPath" class="poster" height="100px" :width="width"></v-img>
            <div class="pl-2">
              <h4>{{ item.name }}</h4>
              <span v-if="medium === $mediums.FILM && item.year"> ({{ item.year }})</span>
              <span v-if="medium === $mediums.BOOK || medium === $mediums.ALBUM"> -{{ item.creators.join(", ") }}</span>
            </div>
          </div>
        </v-list-item>
        <v-divider :key="item.id + 'b'"></v-divider>
      </template>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "MediaSearch",
  props: {
    medium: String,
  },

  data: () => ({
    input: {
      title: "",
    },
    results: [],
    searchAllowed: true,
    timedSearch: undefined,
    latestTimeOfSearch: 0,
  }),

  computed: {
    width() {
      return [this.$mediums.PODCAST, this.$mediums.ALBUM].includes(this.medium) ? 100 : 66;
    },
  },

  methods: {
    search: async function () {
      if (this.input.title === "") {
        this.results = [];
        return;
      }
      const timeOfSearch = Date.now();
      const response = await this.$axios.get("/v1/search", {
        params: {
          q: this.input.title,
          category: this.medium,
          limit: 20,
        },
      });
      if (timeOfSearch < this.latestTimeOfSearch) {
        return;
      }
      this.latestTimeOfSearch = timeOfSearch;
      const items = response.data.items;
      const resultsFound = items.length > 0;
      if (resultsFound) {
        this.results = items.map((item) => ({
          name: item.title,
          posterPath: item.posterSource,
          id: item.id,
          year: item.releaseDate ? item.releaseDate.substring(0, 4) : undefined,
          creators: item.creators.map((item) => item.name),
        }));
      }
    },

    searchTimer: function () {
      window.clearTimeout(this.timedSearch);
      this.timedSearch = window.setTimeout(this.search, 500);
    },

    selectWork: async function (item) {
      this.input.title = item.name;
      this.results = [];
      this.$emit("workSelected", {
        id: item.id,
        title: item.title,
        medium: this.medium,
        poster_source: item.posterPath,
        year: item.releaseDate ? item.releaseDate.substring(0, 4) : undefined,
      });
    },
  },
};
</script>

<style scoped>
.poster {
  float: left;
}
</style>
